import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
import React from "react";
import {
  ErrorOutline,
  HourglassEmpty,
  CheckCircleOutline,
  QuestionMark,
} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

function UserMessage({ message }) {
  const textSegments = message.text.split("\n");

  let statusMessage = "";
  switch (message.status) {
    case "pending":
      statusMessage = <HourglassEmpty color="secondary" />;
      break;
    case "success":
      statusMessage = <CheckCircleOutline color="success" />;
      break;
    case "failed":
      statusMessage = <ErrorOutline color="error" />;
      break;
    default:
      statusMessage = <QuestionMark color="info" />;
      break;
  }

  return (
    <Grid item xs={11} marginLeft="auto" py={2}>
      <Card sx={{ backgroundColor: "background", padding: 1 }} px={2}>
        <MKTypography variant="body2" color="text">
          {textSegments.map((segment, index) => (
            <React.Fragment key={index}>
              {segment}
              {index < textSegments.length - 1 && <br />}
            </React.Fragment>
          ))}
        </MKTypography>
        <MKTypography variant="button" color="text" align="right" paddingTop={1}>
          <Tooltip title={message.status} placement="top">
            {statusMessage}
          </Tooltip>
          {"  "}
          {new Date(message.createdAt).toLocaleDateString("nl-NL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </MKTypography>
      </Card>
    </Grid>
  );
}

export default UserMessage;

UserMessage.propTypes = {
  message: PropTypes.object.isRequired,
};
